import {Injectable} from '@angular/core';
import { ODataEntitySetService, ODataServiceFactory } from 'angular-odata';
import {Scope} from '../../models/scope';
import { HttpClient } from '@angular/common/http';
import {ParentTableService} from '../table/parent-table.service';
import {exportable$} from '../table/decorators/exportable';
import {map} from 'rxjs/operators';
import {ODataResponseMapper} from '../table/mappers/odata-response-mapper';
import {HelperFunctions} from '../table/configuration/helper-functions';
import {SQDataConfiguration} from '../table/configuration/OData-configuration';

@Injectable()
export class ScopeService extends ParentTableService {
  private odata: ODataEntitySetService<Scope>;
  private readonly config: SQDataConfiguration;
  @exportable$ scope: any;

  constructor(public readonly odataFactory: ODataServiceFactory, private readonly http: HttpClient) {
    super('ScopeService');
    this.odata = this.odataFactory.entitySet<Scope>('Overview(0)/NominationScope');
    this.config = new SQDataConfiguration();
  }

  public getCommodities(): any {
    return this.http.get(this.config.baseUrl + '/Commodity');
  }

  getData(pageIndex, count, sortModel, filterModel) {
    const orders = [];
    sortModel.forEach(x => orders.push(x.colId.replace(/\./g, '/') + ' ' + x.sort));

    let filter = 'true';
    filter = HelperFunctions.addOdataFilters(filter, filterModel);

    const query = this.odata.entities().query(q => {
      q.top(count);
      q.skip(count * pageIndex);
      if (orders.length > 0) q.orderBy(orders);
      if (filter?.length) q.filter(filter);
      return q;
    });

    this.scope = query;
    return this.scope.fetch({ withCount: true }).pipe(map((r: any) => ODataResponseMapper.mapResponse(r)));
  }

  getScopeStatuses() {
    return this.http.get(this.config.apiBaseUrl + 'ScopeStatus');
  }

  isExistingScope(portalmid: number) {
    return this.odata.entities().query(q => {
      q.filter(`PortalMId eq ${portalmid}`);
      return q;
    }).fetch({ withCount: true }).pipe(map((r: any) => ODataResponseMapper.mapResponse(r)));
  }

  addOrUpdateScope(scope: Scope) {
    return this.http.post(this.config.apiBaseUrl + 'Scope', scope);
  }

  deleteScope(scope: Scope) {
    return this.http.delete(this.config.apiBaseUrl + 'Scope/' + scope.Id);
  }

  getScopeById(id: number) {
    return this.http.get<Scope>(this.config.apiBaseUrl + 'Scope/' + id);
  }
  getQualificationsState(id: number) {
    return this.http.get(`${this.config.apiBaseUrl}Scope/${id}/Qualifications/State`);
  }
}
